import React from "react";

const TitleComponent = ({ headerDetails }) => {
  return (
    <div
      className="d-flex flex-wrap justify-content-between align-items-center"
      style={{
        backgroundColor: "rgb(165 210 255)",
        height: "40px",
        padding: "5px",
        borderRadius: "4px",
        boxShadow: " 5px white",
      }}
    >
      <div className="detail-item me-3">
        <span className="fs-6 text-dark">Patient Name:</span>{" "}
        <small style={{fontWeight:"700"}}>{headerDetails?.patient_name || ""}</small>
      </div>
      <div className="detail-item me-3">
        <span className="fs-6 text-dark">Appointment ID:</span>{" "}
        <small style={{fontWeight:"700"}}>{headerDetails?.appointment_id || ""}</small>
      </div>
      <div className="detail-item me-3">
        <span className="fs-6 text-dark">Lab No:</span>{" "}
        <small style={{fontWeight:"700"}}>{headerDetails?.lab_no || ""}</small>
      </div>
      <div className="detail-item me-3">
        <span className="fs-6 text-dark">Age:</span>{" "}
        <small style={{fontWeight:"700"}}>
          {headerDetails?.patient_age
            ? `${headerDetails.patient_age.year}Y ${headerDetails.patient_age.month}M ${headerDetails.patient_age.days}D`
            : ""}
        </small>
      </div>
      <div className="detail-item me-3">
        <span className="fs-6 text-dark">Gender:</span>{" "}
        <small style={{textTransform:"capitalize", fontWeight:"700"}}>{headerDetails?.gender || ""}</small>
      </div>
      <div className="detail-item me-3">
        <span className="fs-6 text-dark">Franchise:</span>{" "}
        <small style={{fontWeight:"700"}}>{headerDetails?.franchise || ""}</small>
      </div>
    </div>
  );
};

export default TitleComponent;
